import { Dispatch } from 'react';
import {
  InsuranceJourneyInsuranceProductsType,
  InsuranceOptionalProduct
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const OptioanlCoverPageEventHandlers = (
  insuranceProducts: InsuranceJourneyInsuranceProductsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onUpdateSelectedOptionalProduct: (
      optionalProducts: InsuranceOptionalProduct[]
    ) => {
      dispatch({
        type: 'set-optional-cover-details',
        insuranceProducts: {
          ...insuranceProducts,
          optionalProductList: [...optionalProducts]
        }
      });
    }
  };
};
